import React from 'react'
import { IconButton, makeStyles } from '@material-ui/core'

import { getDefaultSchedule } from './index'
import Schedule from './Schedule'
import EventEditor from './EventEditor'

const useCreateSectionStyle = makeStyles((theme) => ({
  addButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '24ch',
  },
  addButton: {
    color: 'green',
    borderRadius: '5px',
    border: '1px solid #c8c8c8',
    padding: '5px',
    marginRight: '0.5em',
    transition: 'background-color 0.5s ease',
    '&:hover': {
      backgroundColor: '#ceffd3',
    },
  },
}))

const MultiCreateSection = (props) => {
  const {
    edits,
    event,
    schedules,
    onChange,
    onAdd,
    onRemove,
    scheduledEventProps,
    setScheduledEventProps,
  } = props

  const classes = useCreateSectionStyle()

  const handleChangeSchedule = (newSchedule, index) => {
    onChange(index, newSchedule)
  }

  const handleAddNewSchedule = () => {
    onAdd(getDefaultSchedule({ until: edits.startDateTime }))
  }

  return (
    <div>
      {schedules.map((schedule, i) => {
        return (
          <Schedule
            event={event}
            edits={edits}
            key={i}
            schedule={schedule}
            onChange={(schedule) => handleChangeSchedule(schedule, i)}
            onRemove={() => onRemove(i)}
          />
        )
      })}
      <div className={classes.addButtonContainer}>
        <IconButton
          className={classes.addButton}
          variant='contained'
          onClick={handleAddNewSchedule}
        >
          <i className='fa fa-plus' />
        </IconButton>
        Add Another Schedule
      </div>
      <EventEditor
        edits={edits}
        schedules={schedules}
        scheduledEventProps={scheduledEventProps}
        setScheduledEventProps={setScheduledEventProps}
      />
    </div>
  )
}

export default MultiCreateSection
